import React, { useMemo } from 'react';
import ChangeGameItem from './changeGameItem';
import { Menu } from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { Link, useIntl, useLocation } from 'umi';
import MenuSearch from './MenuSearch';
import type { MenuItem } from './MenuSearch/types';
import { GAME_LIST_URL } from '@op/constants/page';

const fixedListMenu = [
  {
    to: GAME_LIST_URL,
    icon: 'outline-gamepad',
    title: 'Game List',
  },
  {
    to: '/opinion/AITaskCenter',
    icon: 'ai-task',
    title: 'AI Task Center',
  },
];

type NavHeaderProps = {
  isExpand: boolean;
  toggleExpand: () => void;
  listMenu?: MenuItem[];
  wholeGameInfo?: {
    edition_unified_id?: string;
    [key: string]: any;
  };
  hideGameListMenu?: boolean;
};

export default function Index({
  isExpand,
  toggleExpand,
  listMenu = [],
  wholeGameInfo = {},
  hideGameListMenu = false
}: NavHeaderProps) {
  const { formatMessage } = useIntl();

  const location = useLocation();
  const selected = useMemo(() => {
    // Report Path有的情况下就是以这个为主
    const reportPath = location?.query?.redirect;
    if (reportPath) {
      return '/opinion/AITaskCenter';
    }

    const curPathname = decodeURIComponent(location.pathname);
    return curPathname;
  }, [location]);

  return (
    <div className="navmenu-hd">
      {isExpand ? (
        <div>
          <div className="navmenu-hd-title">
            {formatMessage({ id: 'Opinions' })}
          </div>
          {fixedListMenu.map(({ to, icon, title }) => {
            if(hideGameListMenu && title === "Game List"){
              return null;
            }
            return (
              <Menu.Item
                key={to}
                className={`menu-context-primary ${
                  to === selected ? 'is-selected' : ''
                }`}
                render={(children) => {
                  return <Link to={to}>{children}</Link>;
                }}
                icon={<SvgIcon className="left-nav-icon" type={icon} />}
                title={
                  <span className="menu-context-text menu-context-text-game-list">
                    {formatMessage({ id: title })}
                  </span>
                }
              ></Menu.Item>
            );
          })}
          <ChangeGameItem></ChangeGameItem>
        </div>
      ) : (
        <>
          <div className="header-width" onClick={() => toggleExpand()}>
            <SvgIcon className="header-width-title" type="merit" />
          </div>
          <div className="width-item-icon " onClick={() => toggleExpand()}>
            <SvgIcon type="outline-gamepad" />
          </div>
          <div className="header-width" onClick={() => toggleExpand()}>
            <SvgIcon className="header-width-icon" type="left-turn-right" />
          </div>
        </>
      )}
      {isExpand && (
        <div className="dbo-navmenu-hd-search-wrapper">
          <MenuSearch listMenu={listMenu} wholeGameInfo={wholeGameInfo} />
        </div>
      )}
    </div>
  );
}
